import { render, staticRenderFns } from "./Contactp.vue?vue&type=template&id=0b071908&"
import script from "./Contactp.vue?vue&type=script&lang=js&"
export * from "./Contactp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports